import React from "react";

import { LiveLectureStatusEnum } from "../../enums";
import { getLiveLectureStatusDotColor } from "./liveLectureCalendarUtils";

type TProps = {
  status: LiveLectureStatusEnum;
  size?: number;
  className?: string;
  outlined?: boolean;
};

export const LiveLectureStatusDot: React.FC<TProps> = ({
  status,
  size = 10,
  className = "",
  outlined = false,
}) => (
  <span
    className={`d-inline-block rounded-circle flex-shrink-0 ${className}`.trim()}
    style={{
      width: size,
      height: size,
      backgroundColor: getLiveLectureStatusDotColor(status),
      boxShadow: outlined ? "inset 0 0 0 1.5px rgba(255,255,255,0.95)" : undefined,
    }}
    aria-hidden
  />
);
